import React from 'react';
import {ProductSnippet} from 'components/ProductSnippet/ProductSnippet';
import {IProductShort} from 'modules/products/types';
import {useProductSnippetParams} from 'modules/product-snippet/components/ProductSnippetContainer/hooks';
import {useIsPrive} from 'core/hooks/useIsPrive';
import {IAnalyticsMeta, TSnippetVersion} from 'core/types';
import {useInView} from 'react-intersection-observer';
import {ProductSnippetNew} from 'components/ProductSnippetNew/ProductSnippetNew';
import {IProductSnippet} from 'shared/types/productSnippet.types';
import {useIsWorker} from 'core/hooks/useIsWorker';
import {useIsLoggedIn} from 'modules/user/hooks/useIsLoggedIn';

type TProductSnippetContainerProps = {
    product: IProductShort;
    analyticsData?: IAnalyticsMeta;
    className?: string;
    hasBorder: boolean;
    hasCartActions?: boolean;
    tracking?: {
        skipOnViewTracking: boolean;
    };
    snippetVersion?: TSnippetVersion;
} & Pick<IProductSnippet, 'isCompact'>;

export const ProductSnippetContainer = (props: TProductSnippetContainerProps) => {
    const {
        product,
        analyticsData,
        className,
        hasBorder,
        hasCartActions = true,
        tracking,
        snippetVersion = 'v2',
        isCompact = false,
    } = props;
    const {skipOnViewTracking} = tracking || {skipOnViewTracking: true};

    const isLoggedIn = useIsLoggedIn();
    const isPrive = useIsPrive();
    const isWorker = useIsWorker();

    const params = useProductSnippetParams({product, isPrive, isWorker, isLoggedIn, analyticsData, snippetVersion});

    const {ref} = useInView({
        triggerOnce: true,
        threshold: 0.5,
        onChange: (inView) => {
            if (inView) {
                params.analytics.onProductView();
            }
        },
        skip: skipOnViewTracking,
    });

    return 'v3' === snippetVersion ? (
        <ProductSnippetNew
            ref={ref}
            {...params}
            className={className}
            hasBorder={hasBorder}
            hasCartActions={hasCartActions}
            isCompact={isCompact}
        />
    ) : (
        <ProductSnippet
            ref={ref}
            {...params}
            className={className}
            hasBorder={hasBorder}
            hasCartActions={hasCartActions}
        />
    );
};
